import { ReferralTypes } from '../../typings'
import { SetReferralType } from './typings'

export const setReferralTypeActionCreator = (
  payload: ReferralTypes,
): SetReferralType => ({
  type: 'referrals/setReferralType',
  payload,
})
